<script>
export default {
  props: {
    customAttributeValues: Array,
  },
  methods: {
    icon(customAttributeValue) {
      const value = customAttributeValue.value

      switch (customAttributeValue.castTo) {
        case 'boolean':
          return value ? 'bi-check-circle' : 'bi-circle'
        case 'integer':
          return value == undefined ? 'bi-chat-square' : 'bi-chat-square-text'
        default:
          return !value ? 'bi-chat-square' : 'bi-chat-square-text'
      }
    },
  },
};
</script>

<template>
  <div v-if="this.customAttributeValues" class="d-flex flex-column">
    <template v-for="customAttributeValue in this.customAttributeValues">
      <div>
        <span class="bi" :class="this.icon(customAttributeValue)"></span>
        {{ customAttributeValue.name }}
        <template v-if="customAttributeValue.value || customAttributeValue.castTo == 'integer' && customAttributeValue.value == 0">
          <span v-if="customAttributeValue.castTo == 'integer'">({{ customAttributeValue.value }})</span>
          <span v-else-if="customAttributeValue.castTo == 'date'">(<vueTime :datetime="customAttributeValue.value" format="ccc, dd. LLL yyyy" />)</span>
          <span v-else-if="customAttributeValue.castTo == 'datetime'">(<vueTime :datetime="customAttributeValue.value" format="ccc, dd. LLLL yyyy HH:mm" />)</span>
          <span v-else-if="customAttributeValue.castTo == 'time'">(<vueTime :datetime="customAttributeValue.value" format="HH:mm" />)</span>
        </template>
      </div>
    </template>
  </div>

</template>